const nameInput = /[^A-Za-z0-9\s\.\,\-\@\/\&\'\(\)\*]+/

function getMessage(field, args) {
  return `The ${field} consist of invalid characters.`
}

function validate(value, args) {
  if (value) {
    // if (nameInput.test(value)) {
    //   return false
    // } else {
    //   return true
    // }
    return !(nameInput.test(value))
  } else {
    return true
  }
}

export default {
  getMessage,
  validate
}
